import {Skeleton} from "@/components/ui/skeleton";

interface AvatarProps {
  dark?: boolean;
}

export function AvatarAndLineSkeleton({ dark = false }: AvatarProps) {
  const skeletonColor = dark ? "bg-slate-200" : "bg-white/10";
  return (
    <div className="flex items-center gap-4">
      <Skeleton className={`h-12 w-12 rounded-full  ${skeletonColor}`} />
      <div className="hidden sm:block">
        <Skeleton className={`h-2 w-40  ${skeletonColor}`} />
      </div>
    </div>
  )
}



export function AvatarAndTwoLineSkeleton({ dark = false }: AvatarProps) {
  const skeletonColor = dark ? "bg-slate-200" : "bg-white/10";
  
  return (
    <div className="flex items-center gap-4">
      <Skeleton className={`h-12 w-12 rounded-full ${skeletonColor}`} />
      <div className="flex flex-col gap-2">
        <Skeleton className={`h-2 w-40 ${skeletonColor}`} />
        <Skeleton className={`h-1.5 w-30 ${skeletonColor}`} />
      </div>
    </div>
  )
}
